export default "__VITE_ASSET__D53hHCT4__"